export class ReferralRequest {
  constructor() {
  }

  public patientNationalCode?: string;
  public patientNationalCodeMessage?: string;
  public trackingCode?: string;
  public trackingCodeMessage?: string;
}

export class ReferralPaperDoctorRequest {
  constructor() {
  }

  public medicalCouncilCode?: string;
  public medicalCouncilCodeMessage?: string;
  public visitDate?: string;
  public visitDateMessage?: string;
  public expertiseGrade?: string;
  public expertiseGradeMessage?: string;
}
